/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

if (n === 1)
    return 1;
return 5;
}

export default ["tn-BW",[["a","p"],["AM","PM"]],[["AM","PM"]],[["S","M","T","W","T","F","S"],["Tsh","Mos","Labb","Labr","Labn","Labt","Mat"],["Tshipi","Mosupologo","Labobedi","Laboraro","Labone","Labotlhano","Matlhatso"],["Tsh","Mos","Labb","Labr","Labn","Labt","Mat"]],u,[["1","2","3","4","5","6","7","8","9","10","11","12"],["Fer","Tlh","Mop","Mor","Mot","See","Phu","Pha","Lwe","Dip","Ngw","Sed"],["Ferikgong","Tlhakole","Mopitlo","Moranang","Motsheganang","Seetebosigo","Phukwi","Phatwe","Lwetse","Diphalane","Ngwanatsele","Sedimonthole"]],u,[["BC","AD"],u,["Pele ga tsalo ya Morena Jeso","Morago ga Leso la Morena Jeso"]],0,[6,0],["y-MM-dd","y MMM d","y MMMM d","y MMMM d, EEEE"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1}, {0}",u,"{1} 'ka' {0}",u],[".","’",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","¤#,##0.00","#E0"],"BWP","P",u,{"BWP":["P"],"JPY":["JP¥","¥"],"USD":["US$","$"],"ZAR":["R"]},"ltr", plural];
